export const LOAD_QUESTION_ANALYZERS = "LOAD_QUESTION_ANALYZERS";
export const LOAD_QUESTION_ANALYZERS_SUCCESS =
  "LOAD_QUESTION_ANALYZERS_SUCCESS";
export const LOAD_QUESTION_ANALYZERS_ERROR = "LOAD_QUESTION_ANALYZERS_ERROR";
export const LOAD_SURVEY_SCRIPT = "LOAD_SURVEY_SCRIPT";
export const LOAD_SURVEY_SCRIPT_SUCCESS = "LOAD_SURVEY_SCRIPT_SUCCESS";
export const LOAD_SURVEY_SCRIPT_ERROR = "LOAD_SURVEY_SCRIPT_ERROR";
